import React, { FC } from 'react'
import s from './CardProject.module.scss'
import { BACKEND_URL } from '../../api'
import { Link } from 'react-router-dom'

interface dataProps {
    data: {
        id: number;
        preview_description: string;
        preview_img: string;
        title: string;
    };
}

const CardProject: FC<dataProps> = ({ data }) => {

    return (
        <Link to={`/projects/${data.id}/${data.title}`} className={s.card}>
            <div className={s.box_img}>
                <img src={BACKEND_URL + data.preview_img} alt={data.title} />
            </div>
            <div className={s.box_content}>
                <h2>{data.title}</h2>
                <p>{data.preview_description}</p>
            </div>
            <div className={s.btn}>
                <button>Узнать больше</button>
            </div>
        </Link>
    )
}

export default CardProject
